var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.iconClass,domProps:{"textContent":_vm._s(_vm.name)}})}
var staticRenderFns = []

export { render, staticRenderFns }